import CssBaseline from "@material-ui/core/CssBaseline";
import AppContainer, {
  Auth,
  useCurrentTenant,
} from "@qpr/client-library/dist/esm";
import "App.css";
import "init";
import AppBarContext from "qpr-base/appbar/BusinessPortalAppBarContext";
import useAppBar from "qpr-base/appbar/BusinessPortalAppBarHook";
import interceptorService from "qpr-base/axios/interceptor";
import * as conf from "qpr-base/configuration";
import { AppCtxProvider } from "qpr-base/context/AppCtxProvider";
import { ReportCtxProvider } from "qpr-base/context/ReportCtxProvider";
import { ScrollCtxProvider } from "qpr-base/context/ScrollContextProvider";
import UserContextProvider from "qpr-base/context/UserContextProvider";
import LanguageSwitchView from "qpr-base/languageswitch/LanguageSwitchView";
import { RTLProvider } from "qpr-base/languageswitch/index";
import LogoutPage from "qpr-base/logout/LogoutPage";
import LoginPage from "qpr-base/pages/LoginPage";
import startBatcherService from "qpr-base/querybuilder/QueryBatcher";
import Loader from "qpr-base/ui/components/Loader";
import ErrorBoundary from "qpr-base/ui/errors/index";
import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "resources/init";
import { SelectedReportContextProvider } from "state/SelectedReportContext";
import Theme from "theme/Theme";
import "typeface-open-sans";
import "typeface-roboto";
import Routes from "./Routes";
import BusinessPortalAppBar from "./components/toolbars/BusinessPortalAppBar";

interceptorService.setupInterceptors();
startBatcherService(200);

const getLastEndedMonth = () => {
  const d = new Date();
  let month = d.getMonth() + 1;
  let year = d.getFullYear();
  if (month === 1) {
    month = 12;
    year -= 1;
  } else month -= 1;
  return `${month} / ${year}`;
};

const Pages = () => {
  const tenant = useCurrentTenant();

  conf.setDefaults(
    "defaultModel",
    tenant.metricsModelId ? tenant.metricsModelId.split(".")[1] : ""
  );

  conf.setDefaults("defaultPeriod", getLastEndedMonth());

  conf.setToolbar("LanguageSwitchView", () => <LanguageSwitchView />);

  return (
    <div>
      <Theme>
        <Auth loginPage={<LoginPage />}>
          <UserContextProvider>
            <ReportCtxProvider>
              <AppCtxProvider>
                <AppBarContext.Provider value={useAppBar()}>
                  <SelectedReportContextProvider>
                    <RTLProvider>
                      <ErrorBoundary>
                        <BusinessPortalAppBar />
                        <ScrollCtxProvider>
                          <Routes />
                        </ScrollCtxProvider>
                      </ErrorBoundary>
                    </RTLProvider>
                  </SelectedReportContextProvider>
                </AppBarContext.Provider>
              </AppCtxProvider>
            </ReportCtxProvider>
          </UserContextProvider>
        </Auth>
      </Theme>
    </div>
  );
};
const App = () => {
  return (
    <Router>
      <AppContainer>
        <Switch>
          <Route path="/logout" component={LogoutPage} />
          <Route>
            <CssBaseline />
            <Suspense fallback={<Loader />}>
              <Pages />
            </Suspense>
          </Route>
        </Switch>
      </AppContainer>
    </Router>
  );
};
export default App;
